import React from 'react';
import TableSkeleton from './TableSkeleton';
import ReceiptItemsSkeleton from './ReceiptItemsSkeleton';
import ProductPickerSkeleton from './ProductPickerSkeleton';
import RecentTransactionsListSkeleton from './RecentTransactionsListSkeleton';
import ProductCatalogSkeleton from './ProductCatalogSkeleton';
import OrdersListSkeleton from './OrdersListSkeleton';

type AppSkeletonProps =
  | {
      mode: 'table';
      columnWidths: number[];
      numRows?: number;
      rowHeight?: number;
    }
  | {
      mode: 'receipt_items';
      count?: number;
    }
  | {
      mode: 'product_picker';
      rows?: number;
    }
  | {
      mode: 'recent_transactions';
      count?: number;
    }
  | {
      mode: 'product_catalog';
      count?: number;
      numColumns?: number;
      isRowLayout?: boolean;
      showProductImages?: boolean;
    }
  | {
      mode: 'orders_list';
      count?: number;
    };

const AppSkeleton: React.FC<AppSkeletonProps> = props => {
  switch (props.mode) {
    case 'table':
      return (
        <TableSkeleton
          columnWidths={props.columnWidths}
          numRows={props.numRows}
          rowHeight={props.rowHeight}
        />
      );
    case 'receipt_items':
      return <ReceiptItemsSkeleton count={props.count} />;
    case 'product_picker':
      return <ProductPickerSkeleton rows={props.rows} />;
    case 'recent_transactions':
      return <RecentTransactionsListSkeleton count={props.count} />;
    case 'product_catalog':
      return (
        <ProductCatalogSkeleton
          count={props.count}
          numColumns={props.numColumns}
          isRowLayout={props.isRowLayout}
          showProductImages={props.showProductImages}
        />
      );
    case 'orders_list':
      return <OrdersListSkeleton count={props.count} />;
    default:
      return null;
  }
};

export default AppSkeleton;
